var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from "react";
import { classNames } from "../../Util";
import { disabledCheckStyle } from "../Checkbox/Checkbox";
var Radio = function (_a) {
    var id = _a.id, name = _a.name, value = _a.value, label = _a.label, _b = _a.error, error = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.hideLabel, hideLabel = _d === void 0 ? false : _d, reactHookForm = _a.reactHookForm, onChange = _a.onChange, onBlur = _a.onBlur, checked = _a.checked;
    var generatedId = useId();
    var inputId = id || generatedId;
    return (_jsxs("div", __assign({ className: "flex items-center" }, { children: [_jsx("input", __assign({ id: inputId, name: name, value: value, type: "radio", disabled: disabled, title: label, onChange: onChange, onBlur: onBlur, checked: checked, className: classNames("h-4 w-4 ", error
                    ? "border-red-300 text-red-600 focus:ring-red-500"
                    : "border-gray-300 text-blue-600 focus:ring-blue-500", disabledCheckStyle) }, reactHookForm)), !hideLabel
                ? _jsx("label", __assign({ htmlFor: inputId, className: classNames("ml-3 block text-sm font-medium", disabled
                        ? "text-gray-500"
                        : (error ? "text-red-700" : "text-gray-700")) }, { children: label }))
                : _jsx(_Fragment, {})] })));
};
export default Radio;
